import React, { useState, useEffect } from "react";
import "../styles/DashboardPage.css";
import {
  Users,
  Box,
  TrendingUp,
  TrendingDown,
} from "lucide-react";
import "../styles/ActiveCardstyle.css";

import AdminDashboardTable from "../Components/AdminDashboardtable";
import AdminUserGraph from "../Components/AdminUserGraph";
import AdminTestGraph from "../Components/AdminTestGraph";
import axiosClient from "../api/axiosClient";

const StatsCard = ({
  title,
  value,
  change,
  isUp,
  icon,
  color,
  onClick,
}) => {
  return (
    <div onClick={onClick} className="cardd">
      <div className="card-topp">
        <div>
          <p className="titlee">{title}</p>
          <h2 className="valuee">{value}</h2>
        </div>

        <div
          className="icon-boxx"
          style={{ background: color }}
        >
          {icon}
        </div>
      </div>

      <div
        className="change"
        style={{
          color: isUp ? "#16a34a" : "#dc2626",
          marginTop: "12px",
          display: "flex",
          alignItems: "center",
          gap: "6px",
          fontWeight: "600",
          fontSize: "14px",
        }}
      >
        {isUp ? (
          <TrendingUp size={16} />
        ) : (
          <TrendingDown size={16} />
        )}

        <span>
          {change}{" "}
          {isUp
            ? "up from yesterday"
            : "down from yesterday"}
        </span>
      </div>
    </div>
  );
};

const ActiveUsersCard = ({
  weeklyUsers,
  monthlyUsers,
  dailyUsers,
}) => {
  return (
    <div className="active-users-cardd">
      {/* Header */}
      <div className="active-users-card__headerr">
        <h3 className="active-users-card__titlee">
          Overall Active Users
        </h3>

        <div className="active-users-card__header-iconn">
          📈
        </div>
      </div>

      <div className="active-users-card__listt">
        {/* Daily */}
        <div className="user-statt">
          <div className="user-stat__infoo">
            <div className="user-stat__icon user-stat__icon--primaryy">
              📅
            </div>

            <div className="user-stat__textt">
              <p className="user-stat__labell">
                Daily Users
              </p>

              <span className="user-stat__periodd">
                Today
              </span>
            </div>
          </div>

          <div className="user-stat__metricss">
            <p className="user-stat__valuee">
              {dailyUsers}
            </p>
          </div>
        </div>

        {/* Weekly */}
        <div className="user-statt">
          <div className="user-stat__infoo">
            <div className="user-stat__icon user-stat__icon--successs">
              📊
            </div>

            <div className="user-stat__textt">
              <p className="user-stat__labell">
                Weekly Users
              </p>

              <span className="user-stat__periodd">
                This week
              </span>
            </div>
          </div>

          <div className="user-stat__metricss">
            <p className="user-stat__valuee">
              {weeklyUsers}
            </p>
          </div>
        </div>

        {/* Monthly */}
        <div className="user-statt">
          <div className="user-stat__infoo">
            <div className="user-stat__icon user-stat__icon--warningg">
              🧮
            </div>

            <div className="user-stat__textt">
              <p className="user-stat__labell">
                Monthly Users
              </p>

              <span className="user-stat__periodd">
                This month
              </span>
            </div>
          </div>

          <div className="user-stat__metricss">
            <p className="user-stat__valuee">
              {monthlyUsers}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const DashboardPage = ({
  fetchStats,
  pageSize,
  search,
  data,
  setLoginFilter,
  totalPages,
  pageIndex,
  setSearch,
  setPageIndex,
  setSelectedUser,
  onUserClick,
  totalUsers,
  totalTestsTaken,
  weeklyActiveUsers,
  monthlyActiveUsers,
  dailyActiveUsers,
}) => {
  const [showGraphPopup, setShowGraphPopup] =
    useState(false);

  const [
    showTestGraphPopup,
    setShowTestGraphPopup,
  ] = useState(false);

  // USERS CARD
  const [userStats, setUserStats] = useState({
    value: 0,
    change: "0%",
    isUp: true,
  });

  // TEST CARD
  const [testStats, setTestStats] = useState({
    value: 0,
    change: "0%",
    isUp: true,
  });

  useEffect(() => {
    fetchUserStats();
    fetchTestStats();
  }, []);

  // COMMON PERCENT FUNCTION
  const calculateStats = (arr) => {
  if (!arr || arr.length < 2) {
    return {
      value: 0,
      change: "0%",
      isUp: false,
    };
  }

  const today = Number(
    arr[arr.length - 1].value
  );

  const yesterday = Number(
    arr[arr.length - 2].value
  );

  console.log("TODAY:", today);
  console.log("YESTERDAY:", yesterday);

  let percent = 0;
  let isUp = false;

  if (yesterday === 0) {
    percent = today > 0 ? 100 : 0;
    isUp = today > 0;
  } else {
    percent =
      ((today - yesterday) / yesterday) * 100;

    isUp = percent >= 0;
  }

  console.log("PERCENT:", percent);

  return {
    value: today,
    change: `${Math.abs(percent).toFixed(1)}%`,
    isUp,
  };
};

const token = localStorage.getItem("admintoken");
  // USERS API
  const fetchUserStats = async () => {
    try {
      const res = await axiosClient.get(
        "/auth/admin/userExamDetails",{
           headers: {
          Authorization: `${token}`,
        },
        });
      const graphData =
        res.data.last7Days || [];

      setUserStats(calculateStats(graphData));
    } catch (error) {
      console.log(error);
    }
  };

  // TEST API
  const fetchTestStats = async () => {
    try {
      const res = await axiosClient.get(
        "/auth/admin/userDetails/dayAndMonthAndYears",{
          headers: {
          Authorization: `${token}`,
        },
        });


      const graphData =
        res.data.last7Days || [];

      setTestStats(calculateStats(graphData));
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div style={{ backgroundColor: "#F2F4FA" }}>
      <div className="stats-container">
        {/* USER CARD */}
        <StatsCard
          title="Total User"
          value={totalUsers}
          change={userStats.change}
          isUp={userStats.isUp}
          icon={<Users />}
          color="#dcd6ff"
          onClick={() =>
            setShowGraphPopup(true)
          }
        />

        {/* TEST CARD */}
        <StatsCard
          title="Total Test Taken"
          value={totalTestsTaken}
          change={testStats.change}
          isUp={testStats.isUp}
          icon={<Box />}
          color="#ffe8b5"
          onClick={() =>
            setShowTestGraphPopup(true)
          }
        />

        {/* ACTIVE USERS */}
        <ActiveUsersCard
          weeklyUsers={weeklyActiveUsers}
          monthlyUsers={monthlyActiveUsers}
          dailyUsers={dailyActiveUsers}
        />
      </div>

      {/* USER GRAPH */}
      {showGraphPopup && (
        <AdminUserGraph
          showGraphPopup={
            showGraphPopup
          }
          setShowGraphPopup={
            setShowGraphPopup
          }
          title="Total Users"
          subtitle="User Activity"
        />
      )}

      {/* TEST GRAPH */}
      {showTestGraphPopup && (
        <AdminTestGraph
          showTestGraphPopup={
            showTestGraphPopup
          }
          setShowTestGraphPopup={
            setShowTestGraphPopup
          }
          title="Total Test Taken"
          subtitle="Test Activity"
        />
      )}

      {/* TABLE */}
      <AdminDashboardTable
        search={search}
        totalPages={totalPages}
        pageIndex={pageIndex}
        fetchStats={fetchStats}
        pageSize={pageSize}
        data={data}
        setSearch={setSearch}
        setPageIndex={setPageIndex}
        setLoginFilter={setLoginFilter}
        onUserClick={onUserClick}
        setSelectedUser={setSelectedUser}
      />
    </div>
  );
};

export default DashboardPage;